import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import { CommonUiModule } from '@bcl/common-ui';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    CommonUiModule,
    IonicModule,
  ],
  declarations: [LoginComponent],
  exports: [],
  providers: [TranslatePipe],
})
export class LoginModule {
  constructor() {}
}
